import(/* webpackMode: "eager", webpackExports: ["ResourcesView"] */ "/vercel/path0/app/resources/ResourcesView.tsx");
